import { CheckEnablers } from "@/src/hooks/check-enablers"
import Activate from "./components/Activate"
import Deactivate from "./components/Deactivate"

const Ussd = () => {
    const { data } = CheckEnablers("ussd")

    return (
        <div>
            {!data?.info ? <Activate /> :
                <Deactivate />}
        </div>
    )
}

export default Ussd